import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getGroupList, synchronizeWarehouseGroup } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditGroupModal from './Add_Edit/AddEditGroup';
import DeleteGroupModal from './Delete/DeleteGroup';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getWarehouseGroupList } from '../../../slices/warehouseGroup/thunk';
import { Tooltip } from '@mantine/core';

const GroupsList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorGroups = createSelector(
		state => state.WarehouseGroup,
		data => ({
			dataList: data.itemWarehouseGroupList,
			isLoadingList: data.isLoadingList,
			isGroupSuccess: data.isGroupSuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { dataList, isLoadingList } = useSelector(selectorGroups);

	const selectorWarehouse = createSelector(
		state => state.Warehouses,
		data => ({
			warehouseList: data.warehouseList,
			isLoadingList: data.isLoadingList,
			isWarehouseSuccess: data.isWarehouseSuccess,
			isLoadingWarehouseList: data.isLoadingWarehouseList,
		})
	);

	const { warehouseList, isLoadingWarehouseList } = useSelector(selectorWarehouse);

	useEffect(() => {
		dispatch(getWarehouseGroupList());
	}, []);

	useEffect(() => {
		dispatch(getWarehouseGroupList());
	}, [warehouseList]);

	const [dataGroup, setDataGroup] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Group
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = data => {
		setDataGroup(data);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = data => {
		setDataGroup(data);
		handleToggleModal();
	};


	function synchronize() {
		dispatch(synchronizeWarehouseGroup());
	}


	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'categories',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const dataData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(dataData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const dataData = cellProps.row.original;
													handleClickDelete(dataData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Código SAP', accessorKey: 'code_sap', size: 'auto', },
			{ header: 'Nombre', accessorKey: 'name', size: 'auto', },
			{ header: 'Familia', accessorKey: 'family', size: 'auto', },
			{ header: 'Sub Familia', accessorKey: 'subfamily', size: 'auto', },
			{ header: 'Tipo', accessorKey: 'type', size: 'auto', },
			{ header: 'Sub Tipo', accessorKey: 'subtype', size: 'auto', },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button className='btn btn-label btn-primary' disabled={isLoadingWarehouseList} onClick={() => { synchronize(); }}>
											{isLoadingWarehouseList ? (<i className="label-icon"><Spinner size='sm' /></i>) : <i className="icon-refresh-cw label-icon"></i>} Sincronizar con SAP
										</button>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataGroup({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Grupo
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={dataList || []}
								isLoadingData={isLoadingList}
								nameFile={'categorias'}
								customToolbarActions={({ table }) => (
									<div className="d-flex justify-content-start gap-2">
										<Tooltip label='Sincronizar con SAP' position='top' withinPortal>
											<button className='btn d-flex align-items-center btn-tooltip-hover gap-1' disabled={isLoadingWarehouseList} onClick={() => { synchronize(); }}>
												{isLoadingWarehouseList ? (<i className=""><Spinner size='sm' /></i>) : <i className={`${Icons.refresh} icon-tooltop-size`}></i>} Sincronizar
											</button>
										</Tooltip>
										<Tooltip label='Crear Grupo' position='top' withinPortal>
											<button
												className='btn d-flex align-items-center btn-tooltip-hover gap-1'
												onClick={() => {
													setIsEdit(false);
													setDataGroup({});
													handleToggleModal();
												}}
											>
												<i className='icon-plus icon-tooltop-size'></i>{' '}
												Crear
											</button>
										</Tooltip>
									</div>
								)}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditGroupModal
				dataGroup={dataGroup}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteGroupModal
				dataGroup={dataGroup}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default GroupsList;
